export default __webpack_public_path__ + "c48367ed9c916956a259c70c501cb5da.png";